import React, { useContext, useEffect, useState } from 'react';
import { switchArrayItems } from 'utils/helpers';
import LanguageBarItem from 'components/LanguageBarItem/LanguageBarItem';
import { ICustomerLanguage, IRestaurantsLanguages } from 'types';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './LanguageBar.module.scss';

interface ILanguageBar {
	items: IRestaurantsLanguages[];
}

const LanguageBar: React.FC<ILanguageBar> = ({ items }) => {
	const { setLocalizationLanguage, selectedLocalizationLanguage, restaurantForFullInfo } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const [orderedLanguages, setOrderedLanguages] = useState<ICustomerLanguage[]>([]);

	useEffect(() => {
		const indexOfDefaultLanguage = items.findIndex(
			(el) => el.languageId === restaurantForFullInfo?.defaultLanguageId,
		);
		const orderedByDefaultLanguage = switchArrayItems(items, indexOfDefaultLanguage, 0);
		setOrderedLanguages(orderedByDefaultLanguage);
	}, [items, restaurantForFullInfo?.defaultLanguageId]);

	useEffect(() => {
		const initialLanguage = orderedLanguages.length
			? { id: orderedLanguages[0].languageId, name: orderedLanguages[0].languageName }
			: null;
		setLocalizationLanguage(selectedLocalizationLanguage ? selectedLocalizationLanguage : initialLanguage);
	}, [selectedLocalizationLanguage, orderedLanguages]);

	return (
		<>
			{orderedLanguages.length ? (
				<div className={style.container}>
					{orderedLanguages.map((el) => (
						<LanguageBarItem
							key={el.languageId}
							languageId={el.languageId}
							isActive={selectedLocalizationLanguage?.id === el.languageId}
							onClick={() => setLocalizationLanguage({ id: el.languageId, name: el.languageName })}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default LanguageBar;
